






























import { Component, Vue, Prop } from "vue-property-decorator";
import requestStore from "@/store/requestStore";
import ComboBox from "@/components/Forms/ComboBox.vue";
import { ValidationProvider } from "vee-validate";
import SimpleDialogForm from "@/components/Forms/SimpleDialogForm.vue";
import TextMultiline from "@/components/Forms/TextMultiline.vue";
import { reaction } from "mobx";
import { Observer } from "mobx-vue";

@Observer
@Component({ components: { ComboBox, ValidationProvider, TextMultiline, SimpleDialogForm } })
export default class RequestCancelDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop({ default: "" }) dataCy?: string;

  dispose?: () => void;

  requestStore = requestStore;

  async mounted() {
    const initializeCancelRequestdispose = reaction(
      () => requestStore.RequestCancelDialogOpen,
      () => {
        if (requestStore.RequestCancelDialogOpen) {
          requestStore.initializeCancelRequestData();
        }
      },
      { fireImmediately: true }
    );

    this.dispose = () => {
      initializeCancelRequestdispose();
    };
  }

  handleCloseDialog() {
    requestStore.resetCancelRequest();
    this.$emit("input", false);
  }

  cancelRequest() {
    this.$emit("cancelRequest");
  }

  destroyed() {
    requestStore.resetCancelRequest();
    if (this.dispose) {
      this.dispose();
    }
  }
}
